import BundleType from '~/components/BundleType/BundleType';
import styles from '../common.scss';

interface ISignalSubTitleContentProps {
    item: IBundleEntity;
    quantity: number;
}

export const EnsignSubTitleContent = (props: ISignalSubTitleContentProps) => {
    return (
        <div className={styles.flex}>
            <div className={styles.preBundleTitle}>
                <BundleType item={props.item} />
            </div>
        </div>
    );
};
